import styled, { css } from "styled-components";

export const StyledStatusCopy = styled.div`
    & > * {
        color: inherit;
    };
    ${({ theme, value }) => value < 50 && css`
        color: ${theme.colors.red};
    `};
    ${({ theme, value }) => value >= 50 && value < 100 && css`
        color: ${theme.colors.darkOrange};
    `};
    ${({ theme, value }) => value >= 100 && css`
        color: ${theme.colors.green};
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;